<listview #taskGrid [config]="config" class="page-layout simple left-sidebar inner-sidebar inner-scroll"></listview>
